import { Component, computed, effect, input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PairCode } from '@era/locations-sdk';
import { GenerationType, QrCodeComponent, QrCodeOptions } from '@rocksoft/cdk';
import { environment } from '@rocksoft/environment';

@Component({
  selector: 'era-pairing-code-ui',
  templateUrl: './pairing-code.component.html',
  imports: [QrCodeComponent, ReactiveFormsModule],
})
export class PairingCodeComponent {
  public readonly code = input<PairCode>();

  public readonly codeChars = computed<string[]>(() => {
    const code = this.code();
    return code ? this.populateCodeChars(code.code) : [];
  });
  public pairUrlWithCode: string;

  public pairUrl: string;

  public qrForeground = '#000000';
  public qrGenOptions: QrCodeOptions;

  public noQRCodeScanner = false;

  public formGroup: UntypedFormGroup;

  public readonly environment = environment;

  constructor() {
    this.qrForeground = environment.locations.qrForeground;
    this.pairUrl = environment.locations.pairUrl;

    this.qrGenOptions = {
      version: 5,
      type: GenerationType.Canvas,
      width: 150,
      margin: 0,
      color: {
        dark: this.qrForeground,
      },
    };

    if (environment.local) {
      this.formGroup = new UntypedFormGroup({
        host: new UntypedFormControl('', Validators.required),
      });

      this.formGroup.controls.host.valueChanges.subscribe((host) => {
        const url = new URL(this.pairUrlWithCode);
        url.hostname = host;
        this.pairUrlWithCode = url.href;
      });
    }

    effect(() => {
      const code = this.code();
      const codeValue = code?.code;
      this.pairUrlWithCode = codeValue ? `${this.pairUrl}/${codeValue}` : '';
    });
  }

  private populateCodeChars(code: string): string[] {
    if (!code) {
      return [];
    }

    const chars: string[] = [];
    for (let x = 0; x < code.length; x++) {
      chars.push(code.charAt(x));
    }
    return chars;
  }
}
